// src/utils/autoLogout.js
import { isTokenExpired } from "./auth";

let logoutTimer = null;

// Clear any existing timer
export const clearAutoLogout = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
};

// Set timer to auto-logout at exact expiry
export const setupAutoLogout = (token, navigate) => {
  clearAutoLogout(); // prevent multiple timers

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
    return;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    const expMs = payload.exp * 1000; // convert to milliseconds
    const now = Date.now();

    if (expMs > now) {
      const timeout = expMs - now;
      logoutTimer = setTimeout(() => {
        localStorage.removeItem("token");
        // Force redirect even if not in React component
        window.location.href = "/login";
      }, timeout);
    } else {
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    }
  } catch (e) {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  }
};